// removed by extract-text-webpack-plugin
module.exports = {"container":"Footer__container___16SZK"};